/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliSchoolCycleDto } from '../../models/amoxcalli-school-cycle-dto';

export interface ApiCyclesGet$Json$Params {
  institutionId?: string;
}

export function apiCyclesGet$Json(http: HttpClient, rootUrl: string, params?: ApiCyclesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliSchoolCycleDto>>> {
  const rb = new RequestBuilder(rootUrl, apiCyclesGet$Json.PATH, 'get');
  if (params) {
    rb.query('institutionId', params.institutionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliSchoolCycleDto>>;
    })
  );
}

apiCyclesGet$Json.PATH = '/api/cycles';
